import gql from 'graphql-tag';

export const contactFragment = `
    id
    contactName
    position
    directLine
    cell
    email
    date
    notes
    current
`;

export const ADD_CONTACT = gql`
    mutation createNewContact(
        $operatorID: ID!
        $contactName: String
        $position: String
        $directLine: String
        $cell: String
        $email: String
        $date: String
        $notes: String
        $current: String
    ) {
        createNewContact(
            operatorID: $operatorID
            contactName: $contactName
            position: $position
            directLine: $directLine
            cell: $cell
            email: $email
            current: $current
            date: $date
            notes: $notes
        ) {

            ${contactFragment}
        }
    }
`;

export const EDIT_CONTACT = gql`
    mutation UpdateContact ($id: ID!, $contactName: String, $position: String, $directLine: String, $cell: String, $email: String, $current: String, $date: String, $notes: String)
    {
        UpdateContact(id: $id, contactName: $contactName, position: $position, directLine: $directLine, cell: $cell, email: $email, current: $current, date: $date, notes: $notes)
        {
            ${contactFragment}
        }
    }
`;

export const DELETE_CONTACT = gql`
    mutation DeleteContact($id: ID!){
        DeleteContact(id: $id){
            ${contactFragment}
        }
    }
`;
